/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Dataroom_Declined_Tag2Inputs */

const en_coinvestments_dataroom_declined_tag2 = /** @type {(inputs: Coinvestments_Dataroom_Declined_Tag2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Declined`)
};

/**
* | output |
* | --- |
* | "Declined" |
*
* @param {Coinvestments_Dataroom_Declined_Tag2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_dataroom_declined_tag2 = /** @type {((inputs?: Coinvestments_Dataroom_Declined_Tag2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Dataroom_Declined_Tag2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_dataroom_declined_tag2(inputs)
});
export { coinvestments_dataroom_declined_tag2 as "coInvestments_dataRoom_declined_tag" }